<div
  *ngIf="showWholeSalePrices()"
  class="price-column"
  data-e2e="product-price-wsp"
>
  <span class="text-nowrap price-title" data-e2e="price-type">
    <ng-container i18n="@@wspLabel"> WSP </ng-container>
    <ng-container *ngIf="wsp()?.currency || prices()?.currency">
      ({{ wsp()?.currency ?? prices()?.currency }})
    </ng-container>
  </span>
  <h5 class="mb-0 price-value font-weight-bold" data-e2e="price-value">
    <ng-container *ngIf="!isLoading(); else skeleton">
      <atx-price-range
        data-e2e="price-without-discount"
        [class.line-through]="wspd()"
        [class.old-price]="wspd()"
        [class.mr-1]="wspd()"
        [priceRange]="wsp()"
      ></atx-price-range>
      <atx-price-range
        *ngIf="wspd()"
        data-e2e="price-with-discount"
        class="wsdp-price"
        [priceRange]="wspd()"
      ></atx-price-range>
    </ng-container>
  </h5>
</div>
<div *ngIf="showRrpPrices()" class="price-column" data-e2e="product-price-rrp">
  <span class="text-nowrap price-title" data-e2e="price-type">
    <ng-container i18n="@@rrpLabel"> RRP </ng-container>
    <ng-container *ngIf="rrp()?.currency || prices()?.currency">
      ({{ rrp()?.currency ?? prices()?.currency }})
    </ng-container>
  </span>
  <h5 class="mb-0 price-value font-weight-bold" data-e2e="price-value">
    <ng-container *ngIf="!isLoading(); else skeleton">
      <atx-price-range [priceRange]="rrp()"></atx-price-range>
    </ng-container>
  </h5>
</div>
<div *ngIf="showMarkup()" class="price-column" data-e2e="product-price-markup">
  <span class="text-nowrap price-title" data-e2e="price-type">
    <ng-container i18n="@@markUpLabel"> Mark-up </ng-container>
  </span>
  <h5 class="mb-0 price-value font-weight-bold" data-e2e="price-value">
    <ng-container *ngIf="!isLoading(); else skeleton">
      <atx-price-range [priceRange]="markup()"></atx-price-range>
    </ng-container>
  </h5>
</div>
<ng-template #skeleton>
  <atx-skeleton-basic
    height="1.5rem"
    width="3.2rem"
    borderRadius="10px"
  ></atx-skeleton-basic>
</ng-template>
